import { render } from "./DashboardFooter.vue?vue&type=template&id=9c4637fa"
import script from "./DashboardFooter.vue?vue&type=script&lang=js"
export * from "./DashboardFooter.vue?vue&type=script&lang=js"
script.render = render

export default script